<template>
  <div id="Customer">
    <el-popover
      placement="left-start"
      width="auto"
      trigger="hover"
      transition=""
      ref="popover"
      popper-class="custom-popper-class"
    >
      <img class="phone" src="@/assets/img/home/customerphone.jpg" />

      <template #reference>
        <el-icon class="customer" :bottom="100" :right="32"
          ><Service
        /></el-icon>
        <!-- <img class="customer" src="@/assets/img/home/customer.png" /> -->
      </template>
    </el-popover>
  </div>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
    };
  },
};
</script>
<style scoped lang="less">
#Customer {
  width: 50px;
  height: 50px;
  position: fixed;
  z-index: 999999;
  right: 26px;
  bottom: 36.6rem;
  cursor: pointer;
}

.customer {
  font-size: 40px;
  color: #ffffff;
  background-color: rgb(71, 102, 255);
  border-radius: 6px;
  padding-right: 5px;
  padding-left: 5px;
}
.phone {
  width: 130px;
  height: 200px;
}
@media (max-width: 997px) {
  #Customer {
    width: 10px;
    height: 10px;
    padding-right: 30px;
    right: 8px !important;
    bottom: 29rem;
    .customer {
      font-size: 30px;
      padding-right: 3px;
      padding-left: 3px;
    }
  }
}
</style>
  